/** Format a Date as YYYY-MM-DD in local time. */
export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Default range: from = today − 2 days, to = today (local calendar days). */
export function getDefaultDateRange(): { from: string; to: string } {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 2);
  return {
    from: toDateInputValue(from),
    to: toDateInputValue(to),
  };
}

/** Start of local calendar day → RFC3339 (UTC). */
export function dateToRFC3339Start(dateStr: string): string {
  const d = new Date(`${dateStr}T00:00:00`);
  return d.toISOString();
}

/** End of local calendar day → RFC3339 (UTC). */
export function dateToRFC3339End(dateStr: string): string {
  const d = new Date(`${dateStr}T23:59:59.999`);
  return d.toISOString();
}
